export default __webpack_public_path__ + "static/media/EnikoProfile-edit-3-Frame-Top.82606c85.jpg";